<template>
  <div v-loading="pageInit">
    <div class="user_center_top">
      <img
        @click="toIndex"
        class="finger"
        style="height: 3.646vw; width: 13vw; position: absolute; left: 3.64vw"
        src="../../assets/logo2.png"
      />

      <div class="top_menus">
        <span @click="openSupplierModify">用户中心</span>
        <span @click="toIndex">首页</span>
        <span @click="jumpToTopOrderType('order')">我的订单</span>
        <span>我的收藏</span>
      </div>
      <span
        style="position: absolute; right: 5vw; margin-top: 0.25vw"
        @click="openSupplierModify"
        ><i class="iconfont" style="font-size: 2vw">&#xe642;</i>
        <p style="margin-top: 0; margin-bottom: 0">账户设置</p>
      </span>
      <span
        style="position: absolute; right: 10vw; margin-top: 0.25vw"
        @click="logout"
        ><i class="iconfont" style="font-size: 2vw">&#xe632;</i>
        <p style="margin-top: 0; margin-bottom: 0">退出</p>
      </span>
    </div>
    <div class="user_center_body">
      <div class="user_center_nav">
        <div></div>
        <div class="nav_title">我的订单</div>
        <div @click="paramQuery({})" class="nav_item">
          <i class="iconfont nav_icon">&#xe8a4;</i>全部
        </div>
        <div @click="paramQuery({ orderStatus: 'finish' })" class="nav_item">
          <i class="iconfont nav_icon">&#xe89b;</i>已完成
        </div>
        <div @click="paramQuery({ orderStatus: 'assigned' })" class="nav_item">
          <i class="iconfont nav_icon">&#xe885;</i>待完成
        </div>
        <div @click="paramQuery({ orderStatus: 'finish' })" class="nav_item">
          <i class="iconfont nav_icon">&#xe891;</i>待验收
        </div>
        <div
          @click="paramQuery({ orderStatus: 'acceptanced' })"
          class="nav_item"
        >
          <i class="iconfont nav_icon">&#xe899;</i
          >{{
            checkPermission(["YUMIORDER_SELECT_SUPPLIER"]) ? "待收款" : "待付款"
          }}
        </div>
        <div class="nav_title">通知栏</div>
        <div class="nav_item" @click="openMessageBox('orderStatus')">
          <i class="iconfont nav_icon">&#xe8bc;</i>待办任务
          <div class="dot">
            {{
              msgList.filter((item) => {
                return item.type == "order_status";
              }).length
            }}
          </div>
        </div>
        <div class="nav_item" @click="openMessageBox('orderAccepted')">
          <i class="iconfont nav_icon">&#xe8c0;</i>消息通知
          <div class="dot">
            {{
              msgList.filter((item) => {
                return (
                  item.type == "rob_order" || item.type == "rob_order_result"
                );
              }).length
            }}
          </div>
        </div>
        <div v-if="userInfo.type == 'company'" class="nav_title">
          我的供应商
        </div>
        <div
          v-if="userInfo.type == 'company'"
          class="nav_item"
          @click="$refs['supplierTable'].dialogVisible = true"
        >
          <i class="iconfont nav_icon">&#xe7e8;</i>供应商列表
        </div>
      </div>
      <div class="user_center_main">
        <info :info="userInfo"></info>

        <div class="trade_data">
          <div
            style="
              display: flex;
              justify-content: space-around;
              width: 100%;
              color: #383838;
              font-size: 1.354vw;
            "
          >
            <span>交易总额</span>
            <span
              >合计：￥{{
                IndexData.sumPrice ? IndexData.sumPrice.toFixed(2) : "0"
              }}</span
            >
          </div>
          <div>
            <el-date-picker
              v-model="timeBetween"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <el-button size="mini" type="primary" @click="queryAmountByTime"
              >搜索</el-button
            >
          </div>
          <div class="month_Data">
            <div v-for="(item, index) in monthData" :key="index">
              {{ item.months }}交易额 {{ item.sumamount.toFixed(2) }}元
            </div>
            <!-- <div class="data_line"></div> -->
          </div>
        </div>

        <div class="user_alert">
          <el-carousel
            style="width: 100%"
            height="2.36vw"
            direction="vertical"
            :autoplay="true"
          >
            <el-carousel-item v-for="(item, index) in msgCarousel" :key="index">
              <div style="line-height: 2.36vw; font-size: 1.5vw">
                <span style="color: deeppink">消息提醒:</span>{{ item }}
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="user_data_box">
          <div>
            <img
              style="width: 4.167vw; height: 4.167vw"
              src="../../assets/已完结.png"
            />
          </div>
          <div>我的订单</div>
          <div>{{ IndexData.totalOrder }}</div>
        </div>
        <div class="user_data_box">
          <div>
            <img
              style="width: 4.167vw; height: 4.167vw"
              src="../../assets/待完成.png"
            />
          </div>
          <div>待完成</div>
          <div>{{ IndexData.finishing }}</div>
        </div>
        <div class="user_data_box">
          <div>
            <img
              style="width: 4.167vw; height: 4.167vw"
              src="../../assets/待验收.png"
            />
          </div>
          <div>待验收</div>
          <div>{{ IndexData.accepting }}</div>
        </div>
        <div class="user_data_box">
          <div>
            <img
              style="width: 4.167vw; height: 4.167vw"
              src="../../assets/待收款.png"
            />
          </div>
          <div>
            {{
              checkPermission(["YUMIORDER_SELECT_SUPPLIER"])
                ? "待收款"
                : "待付款"
            }}
          </div>
          <div>{{ IndexData.paying }}</div>
        </div>
        <div class="user_data_box">
          <div>
            <img
              style="width: 4.167vw; height: 4.167vw"
              src="../../assets/已完结.png"
            />
          </div>
          <div>已完结</div>
          <div>{{ IndexData.payed }}</div>
        </div>
        <!--表格-->
        <div id="order" style="margin-bottom: 4vw">
          <div class="table_top">
            <p>订单列表</p>
            <el-button
              v-if="!checkPermission(['YUMIORDER_SELECT_SUPPLIER'])"
              type="success"
              size="mini"
              @click="$refs['release'].dialogVisible = true"
              >发布订单</el-button
            >

            <el-button
              v-if="checkPermission(['YUMIORDER_SELECT_SUPPLIER'])"
              class="filter-item"
              size="mini"
              type="primary"
              icon="el-icon-check"
              @click="batchAction('finish')"
              >批量完成</el-button
            >

            <el-button
              v-if="!checkPermission(['YUMIORDER_SELECT_SUPPLIER'])"
              class="filter-item"
              size="mini"
              type="primary"
              icon="el-icon-check"
              @click="batchAction('acceptanced')"
              >批量验收</el-button
            >

            <el-button
              v-if="!checkPermission(['YUMIORDER_SELECT_SUPPLIER'])"
              class="filter-item"
              size="mini"
              type="primary"
              icon="el-icon-check"
              @click="batchAction('payed')"
              >批量支付</el-button
            >

            <el-button
              v-permission="['YUMIORDER_EDIT_SELF']"
              class="filter-item"
              size="mini"
              type="primary"
              icon="el-icon-plus"
              @click="batchDialog()"
              >批量发布</el-button
            >

            <el-dialog
              :title="dialogTitle"
              :visible.sync="uploadVisible"
              append-to-body="true"
              width="30%"
            >
              <center>
                <el-button
                  type="danger"
                  style="margin-bottom: 50px"
                  @click="downloadTempt"
                  >下载模板文件</el-button
                >
              </center>

              <el-upload
                ref="upload"
                :action="excelUploadApi"
                :limit="1"
                :auto-upload="false"
                :headers="headers"
                :on-success="uploadExcelSuccess"
                :on-error="uploadExcelError"
                name="excelFile"
                class="upload-demo"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >选取文件</el-button
                >
                <el-button
                  style="margin-left: 10px"
                  size="small"
                  type="success"
                  @click="submitUpload"
                  >上传到服务器</el-button
                >
                <div slot="tip" class="el-upload__tip">
                  只能上传xls/xlsx文件
                </div>
              </el-upload>
            </el-dialog>
            <el-dialog
              :title="批量发布结果"
              :visible.sync="uploadResVisible"
              append-to-body="true"
              width="50%"
            >
              <el-table :data="resData" style="width: 100%">
                <el-table-column prop="errorMsg" label="错误信息" width="300" />
                <el-table-column
                  prop="errorResult"
                  label="错误原因"
                  width="180"
                />
              </el-table>
            </el-dialog>
          </div>
          <el-table
            v-loading="loading"
            :data="tableData"
            @selection-change="handleSelectionChange"
            size="small"
            style="width: 100%"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <!-- <el-table-column prop="id" label="订单id"/> -->
            <el-table-column prop="orderNumber" label="订单号" />
            <el-table-column prop="orderName" label="任务名称" />
            <el-table-column prop="orderDescribe" label="订单描述">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  size="mini"
                  @click="openDescribeDialog(scope.row.orderDescribe)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="orderType" label="订单类型">
              <template slot-scope="scope">
                <div v-for="item in dictMap.order_type" :key="item.id">
                  <el-tag
                    v-if="scope.row.orderType == item.value"
                    type="success"
                    >{{ item.label }}</el-tag
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="releaseType" label="发布方式">
              <template slot-scope="scope">
                <el-tag type="success">{{
                  getDictMapItem("release_type", scope.row.releaseType).label
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="releasePattern" label="发布模式">
              <template slot-scope="scope">
                <el-tag type="success">{{
                  getDictMapItem("release_pattern", scope.row.releasePattern)
                    .label
                }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="orderCoefficient" label="核算系数" />
            <el-table-column
              prop="performancefeesCoefficient"
              label="绩效系数"
            />
            <el-table-column
              v-if="!checkPermission(['YUMIORDER_SELECT_SUPPLIER'])"
              prop="yumiSupplier"
              label="供应商"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.yumiSupplier
                    ? scope.row.yumiSupplier.supplierName
                    : ""
                }}</span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="
                checkPermission([
                  'YUMIENTERPRISEUSER_ALL',
                  'YUMIORDER_SELECT_SUPPLIER',
                ])
              "
              prop="enterpriseId"
              label="企业名称"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.enterprise.enterpriseName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="releaseTime" label="发布时间">
              <template slot-scope="scope">
                <span>{{ parseTime(scope.row.releaseTime) }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column v-if="checkPermission(['YUMIENTERPRISEUSER_ALL','YUMIORDER_SELECT_SUPPLIER'])" prop="createDateTime"
						 label="创建时间">
							<template slot-scope="scope">
								<span>{{ parseTime(scope.row.createDateTime) }}</span>
							</template>
						</el-table-column> -->
            <el-table-column
              prop="performanceFees"
              label="应发供应商绩效费（含税）"
            />
            <el-table-column prop="deliveryTime" label="交付时间">
              <template slot-scope="scope">
                <span>{{ parseTime(scope.row.deliveryTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="orderStatus" label="订单状态">
              <template slot-scope="scope">
                <div v-for="item in dictMap.order_status" :key="item.id">
                  <el-tag
                    v-if="scope.row.orderStatus === item.value"
                    :type="
                      scope.row.orderStatus === 'payed' ? 'danger' : 'success'
                    "
                    >{{ item.label }}</el-tag
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="settlementPrice" label="结算价格" />

            <el-table-column
              prop="orderCredentials"
              label="订单凭证"
              align="center"
              width="150px"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="checkPermission(['YUMIORDER_SELECT_SUPPLIER'])"
                  type="success"
                  size="mini"
                  @click="openUploadCredDialog(scope.row)"
                  >点击上传</el-button
                >
                <el-button
                  style="margin-left: 0"
                  type="success"
                  size="mini"
                  @click="openCredDialog(scope.row)"
                  >查看凭证</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="订单详情" align="center" width="150px">
              <template slot-scope="scope">
                <el-button
                  style="margin-left: 0"
                  type="success"
                  size="mini"
                  @click="openDetailDialog(scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              v-if="checkPermission(['YUMIORDER_EDIT_SELF'])"
              label="操作"
              width="150px"
              align="center"
            >
              <template slot-scope="scope">
                <!-- <edit v-permission="['YUMIORDER_EDIT_SELF']" :data="scope.row" :sup_this="sup_this" /> -->
                <el-popover
                  :ref="scope.row.orderNumber"
                  placement="top"
                  width="180"
                >
                  <p>确定删除本条数据吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      size="mini"
                      type="text"
                      @click="$refs[scope.row.orderNumber].doClose()"
                      >取消</el-button
                    >
                    <el-button
                      :loading="delLoading"
                      type="primary"
                      size="mini"
                      @click="subDelete(scope.row)"
                      >确定</el-button
                    >
                  </div>
                  <el-button
                    slot="reference"
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                  />
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              v-if="checkPermission(['YUMIORDER_EDIT_SELF'])"
              label="操作"
              width="150px"
              align="center"
            >
              <template slot-scope="scope">
                <el-popover :ref="scope.row.id" placement="top" width="180">
                  <p>确定支付吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      size="mini"
                      type="text"
                      @click="$refs[scope.row.id].doClose()"
                      >取消</el-button
                    >
                    <el-button
                      :loading="editLoading"
                      type="primary"
                      size="mini"
                      @click="pay(scope.row)"
                      >确定</el-button
                    >
                  </div>
                  <el-button
                    slot="reference"
                    :disabled="scope.row.orderStatus === 'payed' ? true : false"
                    type="danger"
                    size="mini"
                    >{{
                      scope.row.orderStatus === "payed" ? "已支付" : "支付"
                    }}</el-button
                  >
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="margin-top: 2vw; margin-bottom: 2vw"
            @current-change="currentChange"
            background
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <release ref="release"></release>
    <MessageBox ref="messageBox" :msgList="msgArray"></MessageBox>
    <modifyInfoSupllier
      ref="modifyInfoSupllier"
      :super_form="userInfo"
    ></modifyInfoSupllier>
    <modifyInfoEnterprise
      ref="modifyInfoEnterprise"
      :super_form="userInfo"
    ></modifyInfoEnterprise>
    <supplierTable ref="supplierTable"></supplierTable>
    <el-dialog
      :append-to-body="true"
      :visible.sync="uploadCredDialog"
      title="上传凭证"
    >
      <el-upload
        :action="fileUploadApi"
        :headers="headers"
        :on-success="PicUpload"
        list-type="picture-card"
      >
        <i class="el-icon-plus" />
      </el-upload>
    </el-dialog>

    <el-dialog
      width="50%"
      title="订单描述"
      center
      :append-to-body="true"
      :visible.sync="showDescribe"
      ><p style="font-size: 20px">{{ describe }}</p></el-dialog
    >
    <el-dialog :append-to-body="true" title="订单详情" :visible.sync = "showDetail">

      <order-detail :selectRow = "detail">
      </order-detail>

    </el-dialog>
  </div>
</template>

<script>
import release from "../../components/center/release/release.vue";
import MessageBox from "../../components/center/messageBox/messageBox.vue";
import checkPermission from "../../utils/permission.js";
import { mapGetters } from "vuex";
import store from "../../store/index.js";

import {
  getSupplier,
  getSupplierIndexData,
  getSupplierTableData,
} from "../../api/supplier.js";
import {
  getEnterpriseIndexData,
  getEnterpriseTableData,
} from "../../api/company.js";
import initDict from "@/mixins/initDict";
import { parseTime } from "../../utils/index.js";
import info from "../../components/center/info/info.vue";
import { getMsg } from "../../api/mssage.js";
import { getInfo } from "../../api/login.js";
import { getToken } from "../../utils/auth.js";
import modifyInfoSupllier from "../../components/center/modifyInfo/modifyInfoSupllier.vue";
import modifyInfoEnterprise from "../../components/center/modifyInfo/modifyInfoEnterprise.vue";
import { orderBatch } from "@/api/order";
import Swiper from "swiper";
import { queryPerformanceFeesByTime } from "../../api/cus.js";
import common from "../../mixins/common.js";
import supplierTable from "../../components/center/supplierTable/supplierTable.vue";
import { supplierEdit } from "../../api/order.js";
import orderDetail from '@/components/center/detail/orderDetail'
export default {
  components: {
    info,
    release,
    MessageBox,
    modifyInfoSupllier,
    modifyInfoEnterprise,
    supplierTable,
    orderDetail
  },
  mixins: [initDict, common],
  computed: {
    ...mapGetters(["Login"]),

    msgCarousel: function () {
      let msg = [];

      for (var o of this.msgList.filter((item) => {
        if (item.type == "order_status") return item;
      })) {
        msg.push(
          "订单:" +
            JSON.parse(o.data).orderNumber +
            this.getDictMapItem("order_status", JSON.parse(o.data).orderStatus)
              .label
        );
      }

      return msg;
    },
  },
  data() {
    return {
      showDetail:false,
      showDescribe: false,
      downLoading: false,
      dialogTitle: "批量发布",
      uploadVisible: false,
      describe: "",
      headers: {
        Authorization: "Bearer " + getToken(),
      },
      fileUploadApi: process.env.VUE_APP_API_URL + "/api/file",
      excelUploadApi: process.env.VUE_APP_API_URL + "/api/yumiOrderBatchAssign",

      uploadCredDialog: false,
      pageInit: false,
      delLoading: false,
      editLoading: false,
      userInfo: {},
      supplierInfo: {},
      companyInfo: {},
      IndexData: {},
      tableData: [],
      page: 0,
      size: 10,
      total: 0,
      loading: false,
      value1: [],
      msgList: [],
      monthData: [],
      multipleSelection: [],
      msgArray: [],
      timeBetween: [],
      selectRow: {},
      detail:{}
    };
  },
  created() {
    //获取用户余米平台信息
    if (getToken() && !this.Login.username) {
      getInfo().then((res) => {
        this.$store.dispatch("Login", res);
        this.loadPage();
      });
    } else {
      this.loadPage();
    }
  },
  methods: {
    parseTime,
    checkPermission,
    loadPage() {
      console.log("loadPage");
      this.$nextTick(() => {
        this.getDictMap(
          "order_type,settlement_account,order_status,release_type,release_pattern"
        );

        this.pageInit = true;
        if (checkPermission(["YUMIORDER_SELECT_SUPPLIER"])) {
          //供应商
          this.loadingSupplier();
        } else {
          //企业用户
          this.loadingCompany();
        }
      });
    },
    logout() {
      store.dispatch("LogOut").then(() => {
        this.$router.push({
          name: "index",
        }); // 为了重新实例化vue-router对象 避免bug
      });
    },
    loadingSupplier() {
      getMsg("supplier").then((res) => {
        this.msgList = res;
      });
      getSupplierIndexData().then((res) => {
        this.userInfo = res.yumiSupplier;
        this.IndexData = res.centerObj;
        this.monthData = res.monthAmount;
        //this.IndexData = res.content[0]
        this.pageInit = false;
      });
      const sort = "releaseTime,desc";
      let params = {
        page: this.page,
        size: this.size,
        sort: sort,
      };
      this.loading = true;
      this.loadTableData(params);
    },
    loadingCompany() {
      getMsg("enterprise").then((res) => {
        this.msgList = res;
      });
      getEnterpriseIndexData().then((res) => {
        this.userInfo = res.enterpriseUser;
        this.userInfo.type = "company";
        this.IndexData = res.enterpriseUserCenterData;
        this.monthData = res.monthAmount;
        this.pageInit = false;
      });
      const sort = "releaseTime,desc";
      let params = {
        page: this.page,
        size: this.size,
        sort: sort,
      };
      this.loading = true;
      this.loadTableData(params);
    },
    toIndex() {
      this.$router.push({
        name: "index",
      });
    },
    loadTableData(params) {
      this.loading = true;
      if (checkPermission(["YUMIORDER_SELECT_SUPPLIER"])) {
        getSupplierTableData(params).then((res) => {
          this.loading = false;
          this.tableData = res.content;
          this.total = res.totalElements;
        });
      } else {
        getEnterpriseTableData(params).then((res) => {
          this.loading = false;
          this.tableData = res.content;
          this.total = res.totalElements;
        });
      }
    },
    currentChange(e) {
      const sort = "releaseTime,desc";
      let params = {
        page: e - 1,
        size: this.size,
        sort: sort,
      };

      this.loadTableData(params);
    },
    batchDialog() {
      this.dialogTitle = "批量修改";
      this.uploadVisible = true;
    },
    uploadExcelSuccess(response) {
      this.$notify({
        title: "操作成功",
        type: "success",
        duration: 2500,
      });
      this.uploadVisible = false;
      this.uploadResVisible = true;
      this.resData = response;

      this.$parent.init();
    },
    downloadTempt() {
      if (checkPermission(["YUMIENTERPRISEUSER_ALL"])) {
        window.location.href =
          "http://file.yjyumi.com/批量发布派单任务示列-管理员.xlsx";
      } else {
        window.location.href =
          "http://file.yjyumi.com/%E6%89%B9%E9%87%8F%E5%8F%91%E5%B8%83%E6%B4%BE%E5%8D%95%E4%BB%BB%E5%8A%A1%E7%A4%BA%E5%88%97.xlsx";
      }
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    openMessageBox(type) {
      if (type == "orderStatus") {
        this.msgArray = this.msgList.filter((item) => {
          return item.type == "order_status";
        });
      }
      if (type == "orderAccepted") {
        this.msgArray = this.msgList.filter((item) => {
          return item.type == "rob_order" || item.type == "rob_order_result";
        });
      }

      this.$refs["messageBox"].messageBoxShow = true;
    },
    openSupplierModify() {
      if (checkPermission(["YUMIORDER_SELECT_SUPPLIER"])) {
        this.$refs["modifyInfoSupllier"].showSupplierModify = true;
      } else {
        this.$refs["modifyInfoEnterprise"].showEnterpriseModify = true;
      }
    },
    paramQuery(p) {
      const sort = "releaseTime,desc";
      let params = {
        page: this.page,
        size: this.size,
        sort: sort,
        ...p,
      };
      this.loadTableData(params);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchAction(type) {
      if (this.multipleSelection.length == 0) {
        return false; // 没有选择
      }

      var idList = [];

      for (var o of this.multipleSelection) {
        switch (type) {
          case "finish":
            if (o.orderStatus == "assigned") idList.push(o.id);
            break;
          case "acceptanced":
            if (o.orderStatus == "finish") idList.push(o.id);
            break;
          case "payed":
            if (o.orderStatus == "acceptanced") idList.push(o.id);
            break;
        }
      }
      if (idList.length == 0) {
        this.$notify({
          title: "没有符合条件的订单可以进行操作",
          type: "error",
          duration: 2500,
        });
        return false;
      }

      orderBatch(type, idList)
        .then((res) => {
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500,
          });
        })
        .catch((err) => {
          this.$notify({
            title: "操作失败",
            type: "error",
            duration: 2500,
          });
        });
    },
    queryAmountByTime() {
      let params = {
        start: parseTime(this.timeBetween[0]),
        end: parseTime(this.timeBetween[1]),
      };
      queryPerformanceFeesByTime(params).then((res) => {
        if (res) {
          this.monthData = res;
          this.IndexData.sumPrice = 0;
          for (let o of res) {
            this.IndexData.sumPrice = this.IndexData.sumPrice + o.sumamount;
          }
        } else {
          this.IndexData.sumPrice = 0;
        }
      });
    },
    PicUpload(res) {
      
     this.selectRow.orderCredentials = res.data[0]
      
      supplierEdit(this.selectRow).then((res) => {
        console.log(res);
      });
    },
    openUploadCredDialog(row) {
      this.uploadCredDialog = true;
      this.selectRow = row;
    },
    openCredDialog(row) {
        if(row.orderCredentials){
window.location.href = row.orderCredentials;
        }else{
           this.$notify({
            title: "没有凭证",
            type: "error",
            duration: 2500,
          });
        }
        
      
    },
    openDescribeDialog(row) {
      this.showDescribe = !this.showDescribe;
      this.describe = row;
    },
    openDetailDialog(row){

      this.showDetail = !this.showDetail;
      this.detail = row;

    }
  },
};
</script>

<style>
@import url("./userCenter.css");
</style>
